import { ArcheidosKeyType } from '../../keys';

const archeidosKeys: ArcheidosKeyType = {
  archeidos: 'Archeidos',
  characterEnchancer: 'Character enchancer',
  comparison: 'Comparison',
  completed: 'Completed',
  createsHighQualityArchitecturalVisualizationsAndInteriorRendersBasedOnATextDescriptionParticularlyEffectiveForGeneratingConceptualViewsOfBuildingsInteriorDesignsAndArchitecturalPresentations:
    'Creates high-quality architectural visualizations and interior renders based on a text description. Particularly effective for generating conceptual views of buildings, interior designs, and architectural presentations.',
  generalEnchancer: 'General enchancer',
  generationStarted: 'Generation started..',
  imageGenerationFailedPleaseTryAgain:
    'Image generation failed. Please try again.',
  imageGenerator: 'Image generator',
  input: 'Input',
  lockStrength: 'Lock strength',
  originalRetention: 'Original retention',
  prompt: 'Prompt',
  reference: 'Reference',
  renderingImage: 'Rendering image',
  seed: 'Seed',
  sourceImage: 'Source image',
  steps: 'Steps',
  styleTransfer: 'Style transfer',
  transfersTheVisualStyleFromOneImageToAnotherWhilePreservingTheContentAndCompositionOfTheOriginalImageIdealForApplyingaSpecificColorSchemeLightingOrArtisticStyle:
    'Transfers the visual style from one image to another while preserving the content and composition of the original image. Ideal for applying a specific color scheme, lighting, or artistic style.',
  version: 'Version'
};

export default archeidosKeys;
